import { Duration } from 'luxon';

export function formatBytes(bytes: number | null): string {
  if (bytes === null) return '—';
  if (bytes >= 1_073_741_824) return `${(bytes / 1_073_741_824).toFixed(1)} GB`;
  if (bytes >= 1_048_576) return `${(bytes / 1_048_576).toFixed(1)} MB`;
  if (bytes >= 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${bytes} B`;
}

export function formatDurationMs(ms: number): string {
  if (ms < 1000) return '<1s';
  const duration = Duration.fromMillis(ms).shiftTo('hours', 'minutes', 'seconds');
  const parts: string[] = [];
  if (duration.hours >= 1) parts.push(`${Math.floor(duration.hours)}h`);
  if (duration.minutes >= 1) parts.push(`${Math.floor(duration.minutes)}m`);
  if (parts.length < 2 && duration.seconds >= 1) parts.push(`${Math.floor(duration.seconds)}s`);
  return parts.join(' ');
}
